import * as angular from "angular";
import {IController} from "angular";

export class bringozDatePickerCtrl implements IController {

  form: any;
  date: any;
  configTimeZone: string;
  placeholder: string;
  minDate: any;
  maxDate: any;
  name?: string;
  onlyValidPredicate: Function;
  isRequired: boolean;
  isDisabled: boolean;
  isHideLabel: boolean;
  isAllowClear: boolean;
  ngFocus: any;
  onChange: Function;

  private configTimeZoneOffset: any;
  private dateModel: any;
  private minDateModel: any;
  private maxDateModel: any;

  /* @ngInject */
  constructor(private moment, private splitService) {
  }

  $onInit() {
    this.configTimeZoneOffset = this.splitService.getTimeZoneOffsetByDate(this.configTimeZone, Date.now());
    this._setDate(this.date);
    this._setMinDate(this.minDate);
    this._setMaxDate(this.maxDate);

    if (!this.name) {
      this.name = 'selectedDate';
    }
  }

  $onChanges(changes) {
    if (changes.configTimeZone && !changes.configTimeZone.isFirstChange()) {
      this._setDate(this.date);
      this._setMinDate(this.minDate);
      this._setMaxDate(this.maxDate);
    }

    if (changes.date && !changes.date.isFirstChange()) {
      this._setDate(this.date);
      this._setMinDate(this.minDate);
      this._setMaxDate(this.maxDate);
      this._setIsValid(this.date);
    }

    if (changes.minDate && !changes.minDate.isFirstChange() || changes.maxDate && !changes.maxDate.isFirstChange()) {
      this._setDate(this.date);
      this._setMinDate(this.minDate);
      this._setMaxDate(this.maxDate);
      this._setIsValid(this.date);
    }

    if (changes.onlyValidPredicate && !changes.onlyValidPredicate.isFirstChange()) {
      this._setIsValid(this.date);
    }
  }

  onDateChange(date) {
    const dateValue = date ? this.moment(date).valueOf() : undefined;
    this.onChange({selectedDate: dateValue})
  }

  ////////////////////////////////////////////////

  private _setDate(date) {
    this.dateModel = date ?
      this.splitService.getNewDateFormat(date) :
      undefined;
  }

  private _setMinDate(date) {
    this.minDateModel = date ?
      this.splitService.getNewDateFormat(date) :
      undefined;
  }

  private _setMaxDate(date) {
    this.maxDateModel = date ?
      this.splitService.getNewDateFormat(date) :
      undefined;
  }

  private _setIsValid(date) {
    if (!this.form || !this.form[this.name]) {
      return;
    }

    const control = this.form[this.name];

    let isMinValid = true;
    let isMaxValid = true;
    let isPredicateValid = true;

    if (date) {
      const currentMoment = this.moment(date);

      if (this.minDate) {
        isMinValid = currentMoment.isSameOrAfter(this.moment(this.minDate), 'day');
      }

      if (this.maxDate) {
        isMaxValid = currentMoment.isSameOrBefore(this.moment(this.maxDate), 'day');
      }

      if (this.onlyValidPredicate) {
        isPredicateValid = this.onlyValidPredicate(this.dateModel || new Date(date));
      }
    }

    control.$setValidity('isValid', isMinValid && isMaxValid && isPredicateValid);

    if (!isMinValid || !isMaxValid || !isPredicateValid) {
      control.$setTouched();
    }
  }
}

angular
  .module('bringoz.admin.commons')
  .component( 'bringozDatePicker', {
    require: {
      form: '?^form'
    },
    bindings: {
      date: '<',
      configTimeZone: '<',
      placeholder: '<',
      minDate: '<?',
      maxDate: '<?',
      name: '@?',
      onlyValidPredicate: '<?',
      isHideLabel: '<?',
      isRequired: '<?',
      isDisabled: '<?',
      isAllowClear: '<?',
      ngFocus: '<?',
      onChange: '&'
    },
    template: require('./bringoz-date-picker.html').default,
    controller: bringozDatePickerCtrl
  });
